<template>
  <div class="legend-content">
    <h1 style="margin-bottom:16px">
      {{ $t('legendView.heading') }}
    </h1>
    <h2
      v-if="$store.state.legendItems['overlay'].length > 0"
      style="margin-bottom:8px"
    >
      {{ $t('legendView.vectorLayer') }}
    </h2>
    <div
      v-for="(layer, i) in $store.state.legendItems['overlay']"
      :key="i"
    >
      <h3>{{ layer.layer }}</h3>
      <div
        v-for="(legend, j) in layer.legends"
        :key="j + 100"
      >
        <v-list
          disabled
          flat
        >
          <v-list-item
            v-for="(entry, k) in legend"
            :key="entry.title + k"
          >
            <v-list-item-avatar>
              <div
                class="color-preview"
              >
                <legend-icon
                  :l-style="entry.lStyle"
                />
              </div>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="entry.title" />
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </div>
    <h2
      v-if="$store.state.legendItems['chart'].length > 0"
      style="margin-bottom:8px"
    >
      {{ $t('legendView.diagrams') }}
    </h2>
    <div
      v-for="(layer, i) in $store.state.legendItems['chart']"
      :key="i + 200"
    >
      <h3>{{ layer.layer }}</h3>
      <div
        v-for="(legend, j) in layer.legends"
        :key="j + 300"
      >
        <v-list
          disabled
          flat
        >
          <v-list-item
            v-for="(entry, k) in legend"
            :key="entry.title + k"
          >
            <v-list-item-avatar>
              <div
                class="color-preview"
                :style="{background: entry.color}"
              />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="entry.title" />
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </div>
  </div>
</template>

<script>
import LegendIcon from './LegendIcon.vue';
import { Mapable } from '../../mixins/Mapable';

export default {
  name: 'LegendContent',
  components: {
    LegendIcon,
  },
  mixins: [Mapable],
  data() {
    return {
      initdisplay: this.$appConfig.showLegend,
      baseColor: this.$appConfig.baseColor,
      baseColorAccent: this.$appConfig.baseColorAccent,
      iconColor: this.$appConfig.iconColor,
      fab: false,
      showLegendCard: false,
      legendLayers: [],
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    onMapBound() {
    },
  },
};

</script>

<style scoped>
#legend-card {
  position: fixed;
  right: 10px;
  top: 10%;
  max-width: 20%;
  min-width: 10%;
  overflow-y: auto;
  height: 60%;
}
#legend-modal {
  position: fixed;
  top:0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 20;
}
.legend-content {
  margin: 16px;
}
.color-preview {
  width: 30px;
  height: 30px;
  border-radius: 7px;
}
</style>
